export default "<app-login-layout\r\n></app-login-layout>>\r\n";